import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/insight/',
  name: 'insight',
  meta: {
    auth: true
  },
  redirect: {
    name: 'insight/hot'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'hot',
      name: `${pre}hot`,
      component: _import('cep/insight/qbHot'),
      meta: {
        title: '全媒体热点'
      }
    },
    {
      path: 'hotInfo',
      name: `${pre}hotInfo`,
      component: _import('cep/insight/hotInfo'),
      meta: {
        title: 'test'
      }
    },
    {
      path: 'topic',
      name: `${pre}topic`,
      component: _import('cep/insight/topicUp'),
      meta: {
        title: '全媒体热点'
      }
    },
    {
      path: 'hot-detail',
      name: `${pre}hotDetail`,
      component: _import('cep/insight/qbHotDetail'),
      meta: {
        title: '全媒体热点'
      }
    },
    {
      path: 'platform',
      name: `${pre}platform`,
      component: _import('cep/insight/platform'),
      meta: {
        title: '平台热点'
      }
    },
    {
      path: 'edu',
      name: `${pre}edu`,
      component: _import('cep/insight/qbHot2'),
      meta: {
        title: '教育热点'
      }
    },
    {
      path: 'eduDetail',
      name: `${pre}eduDetail`,
      component: _import('insight/eduDetail'),
      meta: {
        title: '高校热点'
      }
    },
    {
      path: 'edu/article',
      name: `${pre}edu-article`,
      //  component: _import('insight/eduHot'),
      component: _import('cep/insight/qbHotEdu'),
      meta: {
        title: '高校爆文'
      }
    },
    {
      path: 'yq',
      name: `${pre}yq`,
      component: _import('insight/yq'),
      meta: {
        title: '全网舆情'
      }
    },
    {
      path: 'area',
      name: `${pre}area`,
      component: _import('insight/area'),
      meta: {
        title: '区域热点'
      }
    },
    {
      path: 'hotword',
      name: `${pre}word`,
      component: _import('insight/word'),
      meta: {
        title: '全网热词'
      }
    },
    {
      path: 'crawl/newmedia',
      name: `${pre}crawl-newmedia`,
      component: _import('insight/crawler/newmedia'),
      meta: {
        title: '新媒体采集'
      }
    },
    {
      path: 'alumnus',
      name: `${pre}alumnus`,
      component: _import('insight/alumnus'),
      meta: {
        title: '知名校友'
      }
    },
    {
      path: 'tomorrow',
      name: `${pre}tomorrow`,
      component: _import('insight/tomorrow'),
      meta: {
        title: '明日热点'
      }
    },
    {
      path: 'industry',
      name: `${pre}industry`,
      component: _import('insight/industry'),
      meta: {
        title: '行业热点'
      }
    },
    {
      path: 'search',
      name: `${pre}search`,
      component: _import('insight/search'),
      meta: {
        title: '全行业热点'
      }
    }

  ])('insight/')
}
